import { render } from "./areaManage.vue?vue&type=template&id=9380beaa&scoped=true"
import script from "./areaManage.vue?vue&type=script&lang=js"
export * from "./areaManage.vue?vue&type=script&lang=js"

import "./areaManage.vue?vue&type=style&index=0&id=9380beaa&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9380beaa"]])

export default __exports__